import React, { useState, forwardRef, useImperativeHandle } from 'react'

import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'

const CompetitionProtocols = forwardRef(({ defaultvar = '' }, ref) => {
  const currencies_protocol = [
    {
      value: 'Отдельные протоколы',
      label: 'Отдельные протоколы',
      help: 'У каждоой номинации свой протокл и свой победитель',
    },
    {
      value: 'Дополнительный общий протокол победителя',
      label: 'Дополнительный общий протокол победителя',
      help: 'Определение победителя в дополнительном протоколе по сумме баллов основных протоколов',
    },
  ]
  const [value, setValue] = React.useState(defaultvar)
  const [error, setError] = useState('')
  const val = () => {
    return value.trim()
  }
  const validate = () => {
    if (value.trim() === '') {
      setError('Продолжительность турнира обязательно')
      return false
    }
    setError('')
    return true
  }

  useImperativeHandle(ref, () => ({
    validate,
    val,
  }))
  return (
    <TextField
      id="competition_type"
      select
      label="Протокол"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      error={!!error}
      // helperText={error}
      variant="filled"
    >
      {currencies_protocol.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
            }}
          >
            <span>{option.label}</span>
            <span
              style={{
                fontSize: '0.8em',
                color: 'gray',
                whiteSpace: 'normal',
              }}
            >
              {option.help}
            </span>
          </div>
        </MenuItem>
      ))}
    </TextField>
  )
})

export default CompetitionProtocols
